/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WalletControllerDtoNotificationSettingUpdateRequest model module.
 * @module model/WalletControllerDtoNotificationSettingUpdateRequest
 * @version 1.0
 */
class WalletControllerDtoNotificationSettingUpdateRequest {
    /**
     * Constructs a new <code>WalletControllerDtoNotificationSettingUpdateRequest</code>.
     * @alias module:model/WalletControllerDtoNotificationSettingUpdateRequest
     */
    constructor() { 
        
        WalletControllerDtoNotificationSettingUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoNotificationSettingUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoNotificationSettingUpdateRequest} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoNotificationSettingUpdateRequest} The populated <code>WalletControllerDtoNotificationSettingUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoNotificationSettingUpdateRequest();

            if (data.hasOwnProperty('perDailyMinimumAlarm')) {
                obj['perDailyMinimumAlarm'] = ApiClient.convertToType(data['perDailyMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('perDailyMaximumAlarm')) {
                obj['perDailyMaximumAlarm'] = ApiClient.convertToType(data['perDailyMaximumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('perRealtimeMinimumAlarm')) {
                obj['perRealtimeMinimumAlarm'] = ApiClient.convertToType(data['perRealtimeMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('xperDailyMinimumAlarm')) {
                obj['xperDailyMinimumAlarm'] = ApiClient.convertToType(data['xperDailyMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('xperDailyMaximumAlarm')) {
                obj['xperDailyMaximumAlarm'] = ApiClient.convertToType(data['xperDailyMaximumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('xperRealtimeMinimumAlarm')) {
                obj['xperRealtimeMinimumAlarm'] = ApiClient.convertToType(data['xperRealtimeMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('hvhDailyMinimumAlarm')) {
                obj['hvhDailyMinimumAlarm'] = ApiClient.convertToType(data['hvhDailyMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('hvhDailyMaximumAlarm')) {
                obj['hvhDailyMaximumAlarm'] = ApiClient.convertToType(data['hvhDailyMaximumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('hvhRealtimeMinimumAlarm')) {
                obj['hvhRealtimeMinimumAlarm'] = ApiClient.convertToType(data['hvhRealtimeMinimumAlarm'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoNotificationSettingUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoNotificationSettingUpdateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} perDailyMinimumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['perDailyMinimumAlarm'] = undefined;

/**
 * @member {Number} perDailyMaximumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['perDailyMaximumAlarm'] = undefined;

/**
 * @member {Number} perRealtimeMinimumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['perRealtimeMinimumAlarm'] = undefined;

/**
 * @member {Number} xperDailyMinimumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['xperDailyMinimumAlarm'] = undefined;

/**
 * @member {Number} xperDailyMaximumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['xperDailyMaximumAlarm'] = undefined;

/**
 * @member {Number} xperRealtimeMinimumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['xperRealtimeMinimumAlarm'] = undefined;

/**
 * @member {Number} hvhDailyMinimumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['hvhDailyMinimumAlarm'] = undefined;

/**
 * @member {Number} hvhDailyMaximumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['hvhDailyMaximumAlarm'] = undefined;

/**
 * @member {Number} hvhRealtimeMinimumAlarm
 */
WalletControllerDtoNotificationSettingUpdateRequest.prototype['hvhRealtimeMinimumAlarm'] = undefined;






export default WalletControllerDtoNotificationSettingUpdateRequest;

